import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "@/lib/api";

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [actorEmail, setActorEmail] = useState("");
  const [action, setAction] = useState("");

  useEffect(() => {
    const t = setTimeout(async () => {
      const params = new URLSearchParams({ limit: "200" });
      if (actorEmail) params.set("actor_email", actorEmail);
      if (action) params.set("action", action);
      try { const r = await api.get(`/admin/audit?${params.toString()}`); setRows(r.data?.entries || []); setTotal(r.data?.total || 0); } catch {}
    }, 250);
    return () => clearTimeout(t);
  }, [actorEmail, action]);

  const exportCsv = async () => {
    const params = new URLSearchParams({ format: "csv", limit: "500" });
    if (actorEmail) params.set("actor_email", actorEmail);
    if (action) params.set("action", action);
    const r = await api.get(`/admin/audit?${params.toString()}`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement("a"); a.href = url; a.download = "gathervoices-audit.csv"; a.click(); window.URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6 sm:p-8 max-w-6xl" data-testid="admin-audit">
      <div className="flex items-baseline justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-semibold">Audit log</h1>
          <p className="text-sm text-[hsl(var(--muted-foreground))]">{total} entries · immutable</p>
        </div>
        <button data-testid="admin-audit-export" onClick={exportCsv} className="inline-flex items-center gap-1.5 h-10 px-3 rounded-xl border border-[hsl(var(--border))] font-semibold text-sm hover:bg-[hsl(var(--muted))]"><Download size={14} /> Export CSV</button>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <input value={actorEmail} onChange={(e) => setActorEmail(e.target.value)} placeholder="Filter by actor email" className="flex-1 min-w-[220px] h-10 px-3 rounded-xl bg-[hsl(var(--card))] border border-[hsl(var(--input))] text-sm" />
        <input value={action} onChange={(e) => setAction(e.target.value)} placeholder="Filter by action (e.g. user.suspend)" className="flex-1 min-w-[220px] h-10 px-3 rounded-xl bg-[hsl(var(--card))] border border-[hsl(var(--input))] text-sm" />
      </div>

      <div className="mt-5 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[hsl(var(--muted))] text-left text-[11px] uppercase tracking-wide text-[hsl(var(--muted-foreground))]">
            <tr>
              <th className="px-4 py-2 font-semibold">When</th>
              <th className="px-4 py-2 font-semibold">Actor</th>
              <th className="px-4 py-2 font-semibold">Action</th>
              <th className="px-4 py-2 font-semibold">Target</th>
              <th className="px-4 py-2 font-semibold">IP</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? <tr><td colSpan={5} className="px-4 py-6 text-center text-xs text-[hsl(var(--muted-foreground))]">No entries.</td></tr>
            : rows.map((r) => (
              <tr key={r.audit_id} className="border-t border-[hsl(var(--border))]">
                <td className="px-4 py-2 text-[11px] text-[hsl(var(--muted-foreground))] whitespace-nowrap">{r.at ? new Date(r.at).toLocaleString() : ""}</td>
                <td className="px-4 py-2"><div className="font-semibold">{r.actor_email}</div><div className="text-[10px] uppercase tracking-wide text-[hsl(var(--muted-foreground))]">{r.actor_role}{r.ai_assisted ? " · AI-assisted" : ""}</div></td>
                <td className="px-4 py-2 font-mono text-[11px]">{r.action}</td>
                <td className="px-4 py-2 text-[11px] text-[hsl(var(--muted-foreground))]">{r.target_type} <span className="font-mono">{(r.target_id || "").slice(0, 10)}</span></td>
                <td className="px-4 py-2 text-[11px] text-[hsl(var(--muted-foreground))]">{r.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
